module.exports = __webpack_public_path__ + "static/daily-task-manager-ed2e2dbef63a38a529f527b14d03bcf4.png";